module.exports = __webpack_public_path__ + "static/media/43.6163c505.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/43.jpg
// module id = 412
// module chunks = 0